export enum Visibility {
  SHOW = 'SHOW',
  HIDE = 'HIDE',
}
